import { render, staticRenderFns } from "./ScoreShop.vue?vue&type=template&id=7db61aa6&scoped=true&"
import script from "./ScoreShop.vue?vue&type=script&lang=js&"
export * from "./ScoreShop.vue?vue&type=script&lang=js&"
import style0 from "./ScoreShop.vue?vue&type=style&index=0&id=7db61aa6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db61aa6",
  null
  
)

export default component.exports